
import SVGClose from 'themesvg/close.svg?inline';
import SVGMidCircleChevronLeft from 'themesvg/mid-circle-chevron-left.svg?inline';
import SVGMidCircleChevronRight from 'themesvg/mid-circle-chevron-right.svg?inline';
import SVGMinus from 'themesvg/minus.svg?inline';
import SVGPlus from 'themesvg/plus.svg?inline';

export default {
	SVGClose,
	SVGMidCircleChevronLeft,
	SVGMidCircleChevronRight,
	SVGMinus,
	SVGPlus
}
